// src/composables/useFormattedDate.js

import jalaliMoment from 'jalali-moment';
import { useI18n } from 'vue-i18n';

export function useFormattedDate() {
    const { locale } = useI18n({ useScope: 'global' });

    const getFormattedDate = (timestamp, format = {}) => {
        const date = new Date(timestamp);
        const jalaliDate = jalaliMoment(date);

        // Set default formats if none is provided
        const defaultJalaliFormat = 'jYYYY/jMM/jDD';
        const defaultGregorianFormat = 'YYYY/MM/DD';

        return locale.value === 'fa'
            ? jalaliDate.locale('fa').format(format.jalali || defaultJalaliFormat)
            : jalaliDate.format(format.gregorian || defaultGregorianFormat);
    };

    return { getFormattedDate };
}
